import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/LoginContainer/Login';
import Welcome from './components/Welcome/Welcome';
import Dashboard from './components/Dashboard/Dashboard';
import SignupPage from './components/SignupContainer/SignupPage';
import CategoryPage from './components/Dashboard/Categories';
import SettingsPage from './components/Diary/SettingsPage';
import NotificationPage from './components/Diary/NotificationPage';
import DiaryPage from './components/Diary/Diary';
import BillDashboard from './components/Diary/Bills';
import UserProfile from './components/Dashboard/UserProfile';
import EditProfile from './components/Dashboard/EditProfile';
import Layout from './components/Dashboard/Layout';
import LandingPage from './components/Landing/LandingPage';
import ContactPage from './components/Landing/ContactPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/SignupPage" element={<SignupPage />} />

        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/categories" element={<CategoryPage />} />
          <Route path="/bills" element={<BillDashboard />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/Notification" element={<NotificationPage />} />
          <Route path="/Profile" element={<UserProfile />} />
          <Route path="/profile/:id" element={<UserProfile />} />
          <Route path="/Editprofile" element={<EditProfile />} />
          <Route path="/Editprofile/:id" element={<EditProfile />} />
          <Route path="/diary" element={<DiaryPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
